/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 *
 * @author Hüseyin Yurtseven <hyurtseven@dogantv.com.tr>
 * @modified_date: 01/02/2017
 *
 */
/* jshint ignore:start */

; (function ($) {

    $.fn.unveil = function (threshold, callback) {

        var $w = $(window),
            th = threshold || 0,
            retina = window.devicePixelRatio > 1,
            attrib = retina ? "data-src-retina" : "data-src",
            images = this,
            loaded;

        this.one("unveil", function () {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute("data-src");
            if (source) {
                var $this = $(this);
                var w = $this.width();
                var h = $this.height();

                var r = new RegExp("(.*)/(\\d+)/(\\d+)x(\\d+)/(\\w+)","i");
                if (r.test(source)) {
                    var g = r.exec(source);
                    var sWidth = parseInt(g[3]);
                    var sHeight = parseInt(g[4]);

                    var c = Math.ceil(w / 100) * 100;
                    var f = Math.floor(w / 100) * 100;
                    var r = (c - f) / 2 + f;
                    if (r < w) r = c;

                    w = r;
                    h = Math.round((sHeight * w) / sWidth);

                    w = w ? w : 0;
                    h = h ? h : 0;

                    if(sWidth == 0 && sHeight == 0){
                        source = source.replace("/" + sWidth + "x" + sHeight + "/", "/" + 0 + "x" + 0 + "/");
                    } else {
                        source = source.replace("/" + sWidth + "x" + sHeight + "/", "/" + w + "x" + h + "/");
                    }
                }

                this.setAttribute("src", source);
                if (typeof callback === "function") callback.call(this);
            }
        });

        function unveil() {
            var inview = images.filter(function () {
                var $e = $(this);
                if ($e.is(":hidden")) return;

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger("unveil");
            images = images.not(loaded);
        }

        $w.on("scroll.unveil resize.unveil lookup.unveil load.unveil", unveil);

        unveil();

        return this;

    };

})(window.jQuery || window.Zepto);

/* jshint ignore:end */
